import { useScrollPosition } from '~/hooks/useScrollPosition';

export function ScrollPosition() {
    useScrollPosition();

    return null;
}
